/**
 * @generated SignedSource<<ba7b196e4bb34433861cbe61c2fbbdfd>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type TeamHomeNavigator_storeViewer$data = {
  readonly " $fragmentSpreads": FragmentRefs<"TeamHeader_storeViewer">;
  readonly " $fragmentType": "TeamHomeNavigator_storeViewer";
};
export type TeamHomeNavigator_storeViewer$key = {
  readonly " $data"?: TeamHomeNavigator_storeViewer$data;
  readonly " $fragmentSpreads": FragmentRefs<"TeamHomeNavigator_storeViewer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "TeamHomeNavigator_storeViewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "TeamHeader_storeViewer"
    }
  ],
  "type": "StoreViewer",
  "abstractKey": null
};

(node as any).hash = "e4f5ebc8b346eb3f70f5b767d82a26c4";

export default node;
